<div class="page service-page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
  <h4 class="title">{{ 'pages.service.visitRoom.title' | translate }}</h4>
  <div class="content-wrapper">
    <app-service-steps
      [steps]="steps"
      [activeItem]="currentStep === 'InitializationDone' ? 'PreparedRequestedDocuments' : currentStep"
      [lastAvailableStep]="
        this.application
          ? this.application.initializationStatus === 'InitializationDone'
            ? 'PreparedRequestedDocuments'
            : this.application.initializationStatus
          : 'New'
      "
      [disablePreviousSteps]="this.application ? this.application.initializationStatus === 'InitializationDone' : false"
      [isLoading]="isLoading"
      [isSubmitted]="isSubmitted"
      [hasFormChanged]="hasFormChanged && currentStep !== 'PreparedRequestedDocuments'"
      (stepSelected)="hasFormChanged = false" />
    <div class="form-wrapper">
      @if (!isLoading && client) {
        @if (currentStep === new && client) {
          <app-visit-info-form
            [readingRooms]="readingRooms"
            [readersCardId]="readersCard?.id!"
            [client]="client"
            [application]="application"
            [initialReadingRoomId]="initialReadingRoomId"
            (applicationUpdated)="handleApplicationUpdated($event)"
            (saveDraft)="handleSaveDraft($event)"
            (formChanged)="handleFormChanged($event)" />
        } @else if (currentStep === created && application) {
          <app-visit-room-topic-form
            [application]="application"
            [researchTopics]="researchTopics"
            (applicationUpdated)="handleApplicationUpdated($event)"
            (saveDraft)="handleSaveDraft($event)"
            (formChanged)="handleFormChanged($event)" />
        } @else if (currentStep === PreparedResearchTopics && application) {
          <app-visit-room-document-form
            [application]="application"
            (applicationUpdated)="handleApplicationUpdated($event)"
            (saveDraft)="handleSaveDraft($event)"
            (formChanged)="handleFormChanged($event)" />
        } @else if (currentStep === PreparedRequestedDocuments && application) {
          <app-visit-room-summary
            [clientId]="clientId"
            [readersCard]="readersCard"
            [application]="application"
            [researchTopics]="researchTopics"
            (applicationUpdated)="handleApplicationUpdated($event)" />
        }
      } @else {
        <div class="spinner-wrapper">
          <app-spinner [isLoading]="true" />
        </div>
      }
    </div>
  </div>
</div>

<app-confirm-modal
  [isOpen]="isOpenLeaveConfirm"
  (confirm)="onLeaveConfirm()"
  (cancel)="onLeaveCancel()"
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="continue"
  denyText="cancelBack" />
